// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetMyBookingProductResponse

export type WidgetMyBookingProductApiResponse = {
	id: string;
	name: string;
	quantity: number;
};

export type WidgetMyBookingProduct = {
	id: string;
	name: string;
	quantity: number;
};

export function hydrateWidgetMyBookingProduct(data: WidgetMyBookingProductApiResponse): WidgetMyBookingProduct {
	return { ...data };
}